import Vue from "vue";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.fileUtils) {
            this.fileUtils = options.fileUtils;
        } else if (options.parent && options.parent.$fileUtils) {
            this.$fileUtils = options.parent.$fileUtils;
        }
    },
});

export default class FileUtils {
    constructor(){
    }

    async readFileAsync(file) {
        if (file == null) {
            // eslint-disable-next-line no-unused-vars
            return new Promise(((resolve, reject) => resolve(null)));
        }
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const bytes = Array.from(new Uint8Array(reader.result))
                resolve(bytes);
            };

            reader.onerror = reject;

            reader.readAsArrayBuffer(file);
        });
    }

    getFileType(file) {
        if (file == null) {
            return null;
        }

        const parts = file.name.split(".");
        return parts.pop();
    }
}
